module.exports = __webpack_public_path__ + "img/activity-3@2x.bc5756be.svg";